const content = {
    regulations: "regulamin",
    FAQ: "FAQ"
}

export default content
